namespace advisorop.components.common {

    class SelectCuInvestorController {
        cuinvestor: advisorop.components.advisor.CuInvestorController;
        onInvestorSelected: any;
        selInvestor: domains.IInvestor;
        investor: domains.IInvestor;
        isInvestorFormVisible: boolean = false;
        label: string;
        //noResults: boolean;
        investorType: domains.InvestorType = null;
        entityType: domains.EntityType = null;
        createInvestor: number;

        static $inject = ["advisorService"];
        constructor(public advisorService: services.AdvisorService) {
        }

        $onInit(): void {
            //this.noResults = true;
            this.isInvestorFormVisible = false;
        };

        $routerOnActivate(next, previous) {
        };

        search(searchTerm: string): ng.IPromise<{}> {
            return this.advisorService.searchInvestors(searchTerm, this.investorType, this.entityType).then((response) => {
                return response.data;
            });
        };

        onSelect(item, model, label, event): void {
            var inv: domains.IInvestor = {};
            angular.copy(this.selInvestor, inv);
            this.resetSearch();
            this.onInvestorSelected({ investor: inv });
        };

        resetSearch(): void {
            this.selInvestor = null;
            this.investor = null;
            this.isInvestorFormVisible = false;
            //this.noResults = true;
        };


        onCuInvestorInitialised(me: advisor.CuInvestorController) {
            this.cuinvestor = me;
        };
        onCreateInvestor(investor: domains.IInvestor) {
            let that = this;
            this.cuinvestor.working = true;
            this.advisorService.createInvestor(investor)
                .then(function (response) {
                    toastr.success("Investor successfully created.");
                    that.resetSearch();
                    that.cuinvestor.investorCreatedOrUpdated(response.data);
                    that.cuinvestor.reset();
                    if (that.onInvestorSelected) that.onInvestorSelected({ investor: response.data });
                })
                .catch((response) => {
                    toastr.error("Error " + response.status + " : " + response.data);
                })
                .finally(() => {
                    that.cuinvestor.working = false;
                });
        };
        onUpdateInvestor(investor: domains.IInvestor) {
            //console.log("updating investor to: ", investor);
            let that = this;
            this.cuinvestor.working = true;
            this.advisorService.updateInvestor(investor)
                .then(data => {
                    toastr.success("Investor successfully modified.");
                    that.cuinvestor.investorCreatedOrUpdated(data.data);
                    that.cuinvestor.reset();
                })
                .catch(err => {
                    toastr.error(`Error ${err.status}: ${err.data}`);
                })
                .finally(() => {
                    that.cuinvestor.working = false;
                });
        };
        onCancelInvestor() {
            this.cuinvestor.reset();
            this.isInvestorFormVisible = false;
        };

        fetchJustEntities: boolean = false;

        $onChanges(evt): void {
            for (var key in evt) {
                //if (key === "entities") {
                //    this.fetchJustEntities = this.entities;
                //}

            }
        }


    }



    class SelectCuInvestor implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                onInvestorSelected: "&",
                label: "@",
                investorType: "<",
                entityType: "<",
                createInvestor: "<"
            };
            this.controller = SelectCuInvestorController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/shared/common/select-cu-investor.html';
        }
    }
    angular.module(Constants.APP).component("selectCuInvestor", new SelectCuInvestor());


}